import { Infer, string, number, type } from 'superstruct'

export const LastRoomType = type({
  id: number(),
  name: string(),
})

export type LastRoom = Infer<typeof LastRoomType>
